/* Pocketknife UOM Visibility Utility
   This module accounts for a limitation in the core theme where main-product-blocks only gets rendered on inital page load, not for each variant change.
   This listens to variant changes in the url and updates the UOM visibility accordingly.
   Some variants/UOMs have been flagged as "view only" in the product metafields
   Customers should be able to preview but not purchase these variants.
*/
if (!customElements.get("pk-uom-visibility")) {
  class PkUomVisibility extends HTMLElement {
    variantUOMstate = {}

    constructor() {
      super();
    }

    connectedCallback() {
      console.log('PK registered UOM visiblity utility')

      /* Read in product variant state */
      const dataWrapper = document.getElementById('uom-visibility')
      if (!dataWrapper){
        this.console.error('PK could not find variant data');
        return
      } else {
        this.variantUOMstate = JSON.parse(dataWrapper.textContent);
      }

      /* Listen for variant changes */
      this.listenForUrlChanges(()=>{
        this.toggleVisibility(this.variantUOMstate)
      });


      /* Run on inital page load */
      this.toggleVisibility(this.variantUOMstate)
    }

    toggleVisibility(variantUOMstate){
       const params = new URLSearchParams(window.location.search);
        const variantId = params.get("variant");

        console.log(`PK.variantChangeHandler ${variantId}:${variantUOMstate[variantId] || Object.values(variantUOMstate)[0]}`);

        const isViewOnly = (variantUOMstate[variantId] || Object.values(variantUOMstate)[0]) == 'View' || false

        if (isViewOnly){
          document.querySelector('.m-product-form--wrapper').classList.add('display-none')
        } else {
          document.querySelector('.m-product-form--wrapper').classList.remove('display-none')
        }
        // handlePriceBreaksVisibility(variantId || firstVariantId);
    }

    listenForUrlChanges(callback) {
        const wrap = (type) => {
        const original = history[type];

        return function (...args) {
            const result = original.apply(this, args);
            callback();
            return result;
        };
        };

        history.pushState = wrap("pushState");
        history.replaceState = wrap("replaceState");

        window.addEventListener("popstate", callback);
    }

  }

  customElements.define("pk-uom-visibility", PkUomVisibility);
}
